<template>
    <div>
        <slot name="default" :statusOk="mtaeStatusOk" :mtaeProof="mtaeProof">
            <v-btn-icon
                :disabled="!mtaeStatusOk"
                @click.stop="mtaeProof"
                size="small"
                icon="$oss-download"
            >
            </v-btn-icon>
        </slot>
    </div>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
// import { State2Way } from "@/decorators";
import moment from "moment-timezone";
// import PROFILE_COMPANY from "@/graphql/company/ProfileCompany.gql";
import DECLARATION from "@/graphql/declaration/Declaration.gql";
import DECLARATIONFORM from "@/graphql/declarationForm/DeclarationForm.gql";
import { getPaymentsFromXml } from "@/services/declaration/declarationServices";
import { Component, Vue, toNative, Prop, Emit, Hook } from "vue-facing-decorator";
import {
    convertCerfaNumber,
    getDeclarationProof,
    getBundleProof,
} from "../../../../backend/src/common/declaration/declarationServices";
import {
    DeclarationProofData,
    BundleProofData,
} from "../../../../backend/src/common/types/taxformTypes";

@Component
export class TaxFormEDIReport extends Vue {
    @Prop({ required: true }) taxFormId!: string;
    // @Prop({ required: false }) text: string;
    @Prop({ default: false }) isDeclaration: boolean;
    @Prop({ default: null }) companyFromTaxFormListForAdminMode: TaxFormEDIReportCompany;
    @Prop({ default: null })
    accountingPeriodFromTaxFormListForAdminMode: TaxFormEDIReportAccountingPeriod;

    // @Hook
    // beforeRouteLeave(to, from, next) {
    //     debugger;
    //     if (this.isDirty) {
    //         this.confirmCloseWithoutSaveDialog = true;
    //         this.routerNext = to;
    //     } else {
    //         next();
    //     }
    // }

    // get haveSlot() {
    //     return this.$slots.default !== undefined;
    // }

    // isDirty: boolean = false;

    // confirmCloseWithoutSaveDialog: boolean = false;

    // routerNext: any = {};

    printFormsDialog: boolean = false;

    // @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    // accountingPeriod: any;

    get accountingPeriod(): TaxFormEDIReportAccountingPeriod {
        return (
            this.accountingPeriodFromTaxFormListForAdminMode ||
            this.$store.state.accountingPeriod.selectedAccountingPeriod
        );
    }

    get company(): TaxFormEDIReportCompany {
        return this.companyFromTaxFormListForAdminMode || this.$store.state.selected_company;
    }

    // get userId() {
    //     return this.$store.state.user.id;
    // }

    // get accountingPeriodId() {
    //     return this.accountingPeriod ? this.accountingPeriod.id : "";
    // }

    // get years() {
    //     return ["2021", "2020", "2019"];
    // }

    get periodDocument(): string {
        if (this.declaration.startDate === this.declaration.endDate) {
            return this.formatDate(this.declaration.startDate);
        }
        return `${this.formatDate(this.declaration.startDate)} - ${this.formatDate(this.declaration.endDate)}`;
    }

    formatDate(date: string) {
        return moment(date).format("D MMM YYYY");
    }

    // @Apollo({
    //     query: PROFILE_COMPANY,
    //     variables() {
    //         return {
    //             id: this.company?.profile?.id,
    //         };
    //     },
    //     skip() {
    //         return !this.company?.profile?.id;
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data?.profileCompany?.ogaEnrolment !== null) {
    //                 this.settingsVariables = {
    //                     ogaEnrolmentConfig: {
    //                         address: data.profileCompany.ogaEnrolmentConfig?.address,
    //                         postalCode: data.profileCompany.ogaEnrolmentConfig?.postalCode,
    //                         city: data.profileCompany.ogaEnrolmentConfig?.city,
    //                         designation: data.profileCompany.ogaEnrolmentConfig?.designation,
    //                         numberId: data.profileCompany.ogaEnrolmentConfig?.numberId,
    //                         siret: data.profileCompany.ogaEnrolmentConfig?.siret,
    //                         year: data.profileCompany.ogaEnrolmentConfig?.year,
    //                     },
    //                     ogaEnrolment: data.profileCompany.ogaEnrolment,
    //                     taxSystem: {
    //                         income: this.company.incomeCategory,
    //                         regime: this.company.taxRegime,
    //                         type: this.company.taxSystemType,
    //                     },
    //                 };
    //             }
    //         }
    //     },
    // })
    // settingsVariables: {
    //     ogaEnrolmentConfig: {
    //         address: string;
    //         postalCode: string;
    //         city: string;
    //         designation: string;
    //         numberId: string;
    //         siret: string;
    //         year: string;
    //     };
    //     ogaEnrolment: boolean;
    //     taxSystem: {
    //         income: string;
    //         regime: string;
    //         type: string;
    //     };
    // } = {
    //     ogaEnrolmentConfig: {
    //         address: null,
    //         postalCode: null,
    //         city: null,
    //         designation: null,
    //         numberId: null,
    //         siret: null,
    //         year: null,
    //     },
    //     ogaEnrolment: null,
    //     taxSystem: {
    //         income: null,
    //         regime: null,
    //         type: null,
    //     },
    // };

    // @Apollo({
    //     query: BUNDLE_BALANCES,
    //     variables() {
    //         return {
    //             companyId: this.companyId,
    //             accountingPeriodId: this.accountingPeriodId,
    //         };
    //     },
    //     skip() {
    //         return !this.companyId || !this.accountingPeriodId;
    //     },
    //     async specificResult({ data, loading, networkStatus }: any) {
    //         if (data) {
    //             if (data.bundleBalances?.balances) {
    //                 const balances = data.bundleBalances.balances;
    //                 if (!balances.length) {
    //                     this.balances = [];
    //                     return;
    //                 }
    //                 this.balances = balances;
    //             } else {
    //                 this.balances = [];
    //             }
    //             this.display = true;
    //         } else {
    //             this.balances = [];
    //         }
    //     },
    // })
    // balances: any[] = [];

    @Apollo({
        query: DECLARATION,
        variables() {
            return {
                id: this.taxFormId,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.declaration) {
                    this.declaration = data.declaration;
                }
            }
        },
    })
    declaration: any = null;

    @Apollo({
        query: DECLARATIONFORM,
        variables() {
            return {
                id: this.declaration.form.id,
            };
        },
        skip() {
            return !this.declaration?.form?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.declarationForm) {
                    this.form = data.declarationForm;
                }
            }
        },
    })
    form: any = {};

    get formName(): string {
        if (this.form?.name) {
            return this.form.name;
        }
        if (this.declaration?.sheets?.length && this.declaration.sheets[0]?.form?.name) {
            return this.declaration.sheets[0].form.name;
        }
        return "";
    }

    get formYear(): string {
        if (this.form?.year) {
            return this.form.year;
        }
        if (this.declaration?.sheets?.length && this.declaration.sheets[0]?.form?.year) {
            return this.declaration.sheets[0].form.year;
        }
        return "";
    }

    get formNumber(): string {
        if (this.form?.cerfaNumber) {
            return this.form.cerfaNumber;
        }
        if (this.declaration?.sheets?.length && this.declaration.sheets[0]?.form?.cerfaNumber) {
            const cerfaNumber = convertCerfaNumber(this.declaration.sheets[0].form.cerfaNumber);
            return cerfaNumber;
        }
        return "";
    }

    get mtaeStatusOk() {
        if (this.declaration && this.declaration.status) {
            if (this.declaration.status === "ERROR") {
                return true;
            }
            if (
                this.declaration.status === "SENT" &&
                this.declaration.mtaeId &&
                this.declaration.mtaeStatus !== "OK"
            ) {
                return true;
            }
        }
        return false;
    }

    get bundleProof() {
        const data: BundleProofData = {
            companyName: this.companyName,
            companySiret: this.companySiret,
            incomeCategory: this.companyIncomeCategory,
            accountingEnd: this.accountingEnd,
            accountingStart: this.accountingStart,
            cerfaNumber: this.declarationCerfa,
            mtaeId: this.mtaeId,
            dateSend: this.dateSend,
            processingDate: this.processingDate,
            declarationStatus: this.isStatutDeclaration(),
            statutValidationDate: this.isStatutDateValidate(),
        };
        return getBundleProof(data);
    }

    get xml() {
        return this.declaration?.data?.file || null;
    }

    get paymentsInfo() {
        if (this.xml) {
            return getPaymentsFromXml(this.xml);
        }
        return null;
    }

    get amountPaid() {
        if (this.paymentsInfo?.amountPaid > 0) {
            return this.paymentsInfo.amountPaid.toString();
        }
        return 0;
    }

    get payments() {
        if (this.paymentsInfo?.paymentsList?.length) {
            const paymentsRow: any = [];
            this.paymentsInfo.paymentsList.forEach((payment) => {
                paymentsRow.push({ amount: payment.amount, IBAN: payment.iban, BIC: payment.bic });
            });
            return paymentsRow;
        }
        return [];
    }

    get paymentsRows() {
        if (this.paymentsInfo?.paymentsList?.length) {
            let rows = "";
            this.paymentsInfo.paymentsList.forEach((payment) => {
                rows += `
                <tr>
                    <td>dont ${payment.amount} €</td>
                    <td>IBAN : ${payment.iban} / BIC : ${payment.bic}</td>
                </tr>
                `;
            });
            return rows;
        }
        return "";
    }

    get declarationProof() {
        const data: DeclarationProofData = {
            isMailDetails: false,
            isSiretSlip: true,
            isAccountingFirmOfCompany: false,
            declarationTitle: this.declarationTitle,
            companyName: this.companyName,
            formName: this.formName,
            formYear: this.formYear,
            periodDocument: this.periodDocument,
            amountDeclared: this.declaration.amountDeclared || 0,
            amountPaid: this.amountPaid,
            cerfaNumber: this.formNumber,
            isMTAEID: true,
            mtaeId: this.mtaeId,
            dateSend: this.dateSend,
            companySiret: this.companySiret,
            isPaymentsRows: true,
            payment: this.payments,
            isDeclarationStatus: true,
            processingDate: this.processingDate,
            declarationStatus: this.isStatutDeclaration(),
            statusValidationDate: this.isStatutDateValidate(),
        };
        return getDeclarationProof(data);
    }

    @Emit("mtaeProofEvent")
    async mtaeProof(taxFormId: string) {
        if (this.mtaeStatusOk === true) {
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
            );
            if (this.isDeclaration) {
                WinPrint.document.write(this.declarationProof);
            } else {
                WinPrint.document.write(this.bundleProof);
            }

            WinPrint.onload = () => {
                WinPrint.print();
            };

            WinPrint.document.close();
        }

        this.printFormsDialog = false;
    }

    get declarationCerfa() {
        return this.declaration.mtaeData.declaration.pages;
    }

    get mtaeId() {
        return this.declaration.mtaeId;
    }

    isStatutDeclaration() {
        if (this.declaration.status === "SENT") {
            if (!this.declaration.mtaeStatus) {
                return "Déclaration validée sans envoi";
            }
            if (this.declaration.mtaeStatus !== "OK") {
                return this.declaration.mtaeStatus;
            }
            return "Déclaration envoyée";
        }
        if (this.declaration.status === "EDITION") {
            return "Déclaration en cours d'édition";
        }
        if (this.declaration.status === "VALIDATED_NOT_SENT") {
            return "Déclaration validée sans envoi";
        }
        if (this.declaration.status === "ERROR") {
            let errors: string[] = [];
            for (const error of this.declaration.mtaeData.erreur) {
                const errorText = `/ ${error.numErreur} - ${error.texte}`;
                if (!errors.includes(errorText)) {
                    errors.push(errorText);
                }
            }
            const concatErrors: string = errors.join(" ");
            return `${this.declaration.mtaeStatus} ${concatErrors}`;
        }
    }

    isStatutDateValidate() {
        let formattedDate = "";
        if (this.declaration.status === "SENT" || this.declaration.status === "ERROR") {
            const currentDate = new Date();
            formattedDate = moment(currentDate).format("DD/MM/YYYY");
        } else {
            return this.isStatutDeclaration();
        }

        return formattedDate;
    }

    get accountingStart() {
        const dateString = this.accountingPeriod.start;
        return moment(dateString).format("DD/MM/YYYY");
    }

    get accountingEnd() {
        const dateString = this.accountingPeriod.end;
        return moment(dateString).format("DD/MM/YYYY");
    }

    get dateSend() {
        const dateString = this.declaration.date;
        return moment(dateString).format("DD/MM/YYYY HH:mm");
    }

    get processingDate() {
        const dateString = this.declaration?.mtaeData?.statut?.dateTraitementDGFiP;
        if (dateString) {
            return moment(dateString).format("DD/MM/YYYY");
        }
        return "Pas encore traité";
    }

    get companyName(): string {
        return this.company?.name || "";
    }

    get companySiret(): string {
        return this.company?.siret || "";
    }

    get companyIncomeCategory(): string {
        return this.company?.incomeCategory || "";
    }

    get declarationTitle(): string {
        const rof: string = this.declaration?.mtaeData?.identite?.referenceObligationFiscale;
        if (rof?.startsWith("TVA")) {
            return `EDI - TVA - ${this.companyName}`;
        } else if (rof?.startsWith("CVAE")) {
            return `EDI - CVAE - ${this.companyName}`;
        } else if (rof?.startsWith("IS")) {
            return `EDI - IS - ${this.companyName}`;
        }
        return `EDI - ${this.companyName}`;
    }
}

type TaxFormEDIReportCompany = {
    name: string;
    siret: string;
    incomeCategory: string;
};

type TaxFormEDIReportAccountingPeriod = {
    start: string;
    end: string;
};

export default toNative(TaxFormEDIReport);
</script>
